import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cvStatusPipe'
})
export class CvStatusPipe implements PipeTransform {
  /** Aligns with upload-to-complete flow: open work is Preparing; legacy Reviewed = Completed. */
  private listObj: Record<number, string> = {
    0: 'Pending Submission',
    1: 'Preparing',
    2: 'Preparing',
    3: 'Completed',
    4: 'Completed',
  };

  transform(value: number): string {
    return this.listObj.hasOwnProperty(value) ? this.listObj[value] : '';
  }
}
